import './App.css';
import Nav from './components/Nav';
// import PythonObjectVisualizer from './components/PythonObjectVisualizer';
import Compiler from './pages/Compiler';


function App() {
  
  return (
    <>
      <Nav />
      <Compiler />
    </>
  );
}

export default App;
